import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-green-300 fixed bottom-0 left-0 right-0 p-4"
}
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "flex-grow" }, "Install Tally", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Access your scores anywhere. Install the Tally app.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_close_icon = _resolveComponent("close-icon")!
  const _component_save_icon = _resolveComponent("save-icon")!

  return (_ctx.promptEvent)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.promptEvent = null))
          }, [
            _createVNode(_component_close_icon)
          ])
        ]),
        _hoisted_4,
        _createElementVNode("button", {
          class: "btn primary short full",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.install && _ctx.install(...args)))
        }, [
          _createTextVNode("Install Tally now "),
          _createVNode(_component_save_icon)
        ])
      ]))
    : _createCommentVNode("", true)
}